import React, { PureComponent } from "react";
import Plot from "react-plotly.js";
import CustomizePlotRangeDialog from "./CustomizePlotRangeDialog";
/**
 * generic plotly plot component
 * it is decoupled this much because it is not testable. it fails to import the Plot with jest
 * so avoid to add logic to this component
 * @author Akira Kotsugai
 */
export default class GenericPlot extends PureComponent {
  state = {
    openCustomizeDialog: false,
    wrapped: false,
    toDegrees: false
  };

  handleClickOpen = () => {
    this.setState({ openCustomizeDialog: true });
  };

  handleClose = () => {
    this.setState({ openCustomizeDialog: false });
  };

  handleWrapToggle = () => {
    const { toDegrees, wrapped } = this.state;
    this.props.onGetUnwrappedOutputData(!wrapped, toDegrees);
    this.setState({ wrapped: !wrapped });
  };

  handlePhaseUnitToggle = () => {
    const { toDegrees, wrapped } = this.state;
    this.props.onGetUnwrappedOutputData(wrapped, !toDegrees);
    this.setState({ toDegrees: !toDegrees });
  };

  getZDataRange = () => {
    let type = this.props.data[0].type;
    return type === "heatmap" ||
      type === "surface" ||
      (type === "scatter" && this.props.data[0].zmin && this.props.data[0].zmax)
      ? [this.props.data[0].zmin, this.props.data[0].zmax]
      : null;
  };

  render() {
    const customizeRangeIcon = {
        width: 80,
        height: 80,
        path:
          "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z",
        transform: "matrix(1 0 0 1 -10 -10)"
      },
      unwrapIcon = {
        width: 32,
        height: 32,
        path:
          "M31.875 4.063l-10.938 10.938-7-6.938-9.938 9.938v6l9.938-10 7 7 10.938-11zM4 27.938v-27.875h-4v31.875h32v-4z"
      },
      degreesIcon = {
        width: 32,
        height: 32,
        path:
          "M27 18c-0.5 0-0.9-0.3-1-0.8l0-0.1c-0.6-2.7-3.1-4.8-6-5.2V14c0 0.7-0.4 1.3-1 1.6c-0.6 0.3-1.3 0.1-1.8-0.4l-5.9-5.7C11.1 9.3 11 9.1 11 8.8s0.1-0.5 0.3-0.7l5.9-5.7c0.4-0.4 1.1-0.5 1.6-0.3c0.7 0.3 1.2 1 1.2 1.8v1.9c4.5 0.5 8 4.1 8 8.5V17c0 0.5-0.4 0.9-0.9 1C27.1 18 27 18 27 18z\
           M13.7 30c-0.2 0-0.4 0-0.6-0.1c-0.7-0.3-1.2-1-1.2-1.8v-1.9c-4.5-0.5-8-4.1-8-8.5V15c0-0.5 0.4-0.9 0.9-1c0.5-0.1 1 0.3 1.1 0.8l0 0.1c0.6 2.7 3.1 4.8 6 5.2V18c0-0.7 0.4-1.3 1-1.6c0.6-0.3 1.3-0.1 1.8 0.4l5.9 5.7c0.2 0.2 0.3 0.4 0.3 0.7s-0.1 0.5-0.3 0.7l-5.9 5.7C14.5 29.9 14.1 30 13.7 30z"
      };

    return (
      <div>
        <Plot
          data={this.props.data}
          layout={this.props.layout}
          onClick={this.props.onClick}
          config={{
            toImageButtonOptions: {
              format: "png",
              height: 500,
              width: 500
            },
            modeBarButtonsToAdd: [
              {
                name: "Customize Range",
                icon: customizeRangeIcon,
                click: this.handleClickOpen
              },
              ...(this.props?.showPhaseUnitToggle
                ? [
                    {
                      name: "Rad to deg switch",
                      icon: degreesIcon,
                      click: this.handlePhaseUnitToggle
                    }
                  ]
                : []),
              ...(this.props?.morePlotlyModeBarButtonsToAdd
                ? this.props.morePlotlyModeBarButtonsToAdd
                : []),
              ...(this.props.onGetUnwrappedOutputData
                ? [
                    {
                      name: "Wrap/Unwrap",
                      icon: unwrapIcon,
                      click: this.handleWrapToggle,
                      attr: false,
                      val: "off",
                      toggle: true
                    }
                  ]
                : [])
            ]
          }}
          onLegendClick={() => {
            return false;
          }}
          onLegendDoubleClick={() => {
            return false;
          }}
        />
        <CustomizePlotRangeDialog
          zDataRange={this.getZDataRange()}
          handleCustomRange={this.props.handleCustomRange}
          open={this.state.openCustomizeDialog}
          layout={this.props.layout}
          handleClose={this.handleClose}
        ></CustomizePlotRangeDialog>
      </div>
    );
  }
}
